/**
     * The function takes an original date string, an offset in hours, and an offset in minutes, and
     * returns a formatted date string adjusted by the specified offset.
     * @returns a formatted date string in the format "MMM DD, YYYY" (e.g. "Jan 01, 2022").
     */
export const formatAdjustedDate = (originalDateString, endDate) => {
    // Convert the original date string to a Date object
    const originalDate = new Date(originalDateString);
      
    // Adjust the date by the specified offset
    if(endDate){
        originalDate.setHours(originalDate.getHours() - 5);
        originalDate.setMinutes(originalDate.getMinutes() - 30);
    } else {
        originalDate.setUTCHours(originalDate.getUTCHours() );
        originalDate.setUTCMinutes(originalDate.getUTCMinutes() );
    }

    // Format the adjusted date in the desired format
    const formattedDate = originalDate.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    });

    return formattedDate;
}

export const formatDateTime = (originalDateString, endDate) => {
    // Convert the original date string to a Date object
    const originalDate = new Date(originalDateString);

    // Adjust the date by the specified offset
    if (endDate) {
        originalDate.setHours(originalDate.getHours() + 5);
        originalDate.setMinutes(originalDate.getMinutes() + 30);
    } else {
        originalDate.setUTCHours(originalDate.getUTCHours());
        originalDate.setUTCMinutes(originalDate.getUTCMinutes());
    }

    const formattedDate = originalDate.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    });

    const formattedTime = originalDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC'
    });

    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    return formattedDateTime;
};

export const formatDateTimeWithTimeZone = (originalDateString, endDate) => {
    // Convert the original date string to a Date object
    const originalDate = new Date(originalDateString);
    const timeZoneOffset = originalDate.getTimezoneOffset();
    originalDate.setMinutes(originalDate.getMinutes() - timeZoneOffset);

    const formattedDate = originalDate.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
    });

    const formattedTime = originalDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC'
    });
    
    const formattedDateTime = `${formattedDate} ${formattedTime}`;
    return formattedDateTime;
};

export const formatDate = (originalDateString, endDate) => {
    // Convert the original date string to a Date object
    const originalDate = new Date(originalDateString);
      
    // Adjust the date by the specified offset
    if(endDate){
        originalDate.setHours(originalDate.getHours() + 5);
        originalDate.setMinutes(originalDate.getMinutes() + 30);
    } else {
        originalDate.setUTCHours(originalDate.getUTCHours() );
        originalDate.setUTCMinutes(originalDate.getUTCMinutes() );
    }

    // Format the adjusted date in the desired format (YYYY-MM-DD)
    const year = originalDate.getUTCFullYear();
    const month = String(originalDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getUTCDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
}